import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_ShCompanySearch = _resolveComponent("ShCompanySearch")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "modal-to": "#sh-companies",
    max_width: "48rem",
    centered: false,
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => _cache[6] || (_cache[6] = [
      _createTextVNode(" Edit Shared Contact ")
    ])),
    content: _withCtx(() => [
      _createVNode(_component_ScrollBar, {
        class: "content",
        "bar-x-offset": "0rem",
        fade: ""
      }, {
        default: _withCtx(() => [
          _cache[7] || (_cache[7] = _createElementVNode("label", null, "Contact First Name", -1 /* HOISTED */)),
          _createVNode(_component_Input, {
            ref: "f_name",
            modelValue: $data.first_name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.first_name) = $event)),
            "vread-from": "valid",
            "onUpdate:valid": $event => (($data.first_name_valid) = $event),
            minlength: 1,
            maxlength: 128,
            required: ""
          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid"]),
          _cache[8] || (_cache[8] = _createElementVNode("label", null, "Contact Last Name", -1 /* HOISTED */)),
          _createVNode(_component_Input, {
            modelValue: $data.last_name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.last_name) = $event)),
            "vread-from": "valid",
            "onUpdate:valid": $event => (($data.last_name_valid) = $event),
            minlength: 1,
            maxlength: 128,
            required: ""
          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid"]),
          _cache[9] || (_cache[9] = _createElementVNode("label", null, "Contact Middle Name", -1 /* HOISTED */)),
          _createVNode(_component_Input, {
            modelValue: $data.middle_name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.middle_name) = $event)),
            "vread-from": "valid",
            "onUpdate:valid": $event => (($data.middle_name_valid) = $event),
            minlength: 1,
            maxlength: 128
          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid"]),
          _cache[10] || (_cache[10] = _createElementVNode("label", null, "Contact Position", -1 /* HOISTED */)),
          _createVNode(_component_Input, {
            modelValue: $data.position,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.position) = $event)),
            "vread-from": "valid",
            "onUpdate:valid": $event => (($data.position_valid) = $event),
            minlength: 2,
            maxlength: 128
          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid"]),
          _cache[11] || (_cache[11] = _createElementVNode("label", null, "LinkedIn ID", -1 /* HOISTED */)),
          _createVNode(_component_Input, {
            modelValue: $data.linkedin_id,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.linkedin_id) = $event)),
            "vread-from": "valid",
            "onUpdate:valid": $event => (($data.linkedin_id_valid) = $event),
            minlength: 1,
            maxlength: 1024,
            required: ""
          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid"]),
          _cache[12] || (_cache[12] = _createElementVNode("label", null, "Shared Company", -1 /* HOISTED */)),
          _createVNode(_component_ShCompanySearch, {
            modelValue: $data.shared_company_id,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.shared_company_id) = $event)),
            required: false
          }, null, 8 /* PROPS */, ["modelValue"])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, {
        disabled: $data.loading,
        onClick: $options.close
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"]),
      _createVNode(_component_Button, {
        primary: "",
        disabled: !$options.can_submit,
        loading: $data.loading,
        onClick: $options.submit
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [
          _createTextVNode(" Update ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "loading", "onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClickOutside"]))
}